import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { instanceToPlain, plainToClass } from 'class-transformer';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CedreHttpOption } from './http.service';

@Injectable({ providedIn: 'root' })
export class PublicHttpClient {
    constructor(private http: HttpClient) {}

    get<T>(url: string, options: CedreHttpOption = {}, accessToken?: string): Promise<T> {
        const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

        return this.http
            .get<T>(url, { ...options, headers: headers })
            .pipe(
                map((data) => (options.toClass ? plainToClass(options.toClass, data) : data)),
                catchError(this.logHttpError<T>(url, 'get'))
            )
            .toPromise();
    }

    post<T>(url: string, body: any | null, options: CedreHttpOption = {}): Promise<T> {
        return this.http
            .post<T>(url, instanceToPlain(body), {
                ...options,
            })
            .pipe(
                map((data) => (options.toClass ? plainToClass(options.toClass, data) : data)),
                catchError(this.logHttpError<T>(url, 'post'))
            )
            .toPromise();
    }

    private logHttpError<T>(url: string, method: string) {
        return (err) => {
            console.error(`PublicHttpClient error from url ${url} and method ${method}`, err);
            return throwError(err);
        };
    }
}
